import { stateOptions } from "./consts";

const extensionUrlMatches = (url, targetUrl) => {
  return (
    typeof url === "string" &&
    (url === targetUrl || url.endsWith(`/${targetUrl}`))
  );
};

export const getQuestionnaireExtensionValue = (item, extensionUrl) => {
  if (!item || !Array.isArray(item.extension)) {
    return null;
  }

  const extension = item.extension.find(ext =>
    extensionUrlMatches(ext && ext.url, extensionUrl)
  );

  if (!extension) {
    return null;
  }

  if (extension.valueString !== undefined) {
    return extension.valueString;
  }
  if (extension.valueCode !== undefined) {
    return extension.valueCode;
  }
  if (extension.valueUri !== undefined) {
    return extension.valueUri;
  }
  if (extension.valueBoolean !== undefined) {
    return extension.valueBoolean;
  }
  if (extension.valueInteger !== undefined) {
    return extension.valueInteger;
  }
  if (extension.value !== undefined) {
    return extension.value;
  }

  return null;
};

const normalizeAnswerValue = value => {
  if (value && typeof value === "object") {
    if (value.value !== undefined) {
      return value.value;
    }
    if (value.code !== undefined) {
      return value.code;
    }
    if (value.id !== undefined) {
      return value.id;
    }
  }

  return value;
};

const buildSubscriberAddressItems = () => {
  return [
    {
      linkId: "subscriberAddressLine1",
      text: "Subscriber Address Line 1",
      type: "string",
      required: true,
      extension: [
        {
          url: "grid-size",
          valueCode: 6,
        },
      ],
    },
    {
      linkId: "subscriberAddressLine2",
      text: "Subscriber Address Line 2",
      type: "string",
      extension: [
        {
          url: "grid-size",
          valueCode: 6,
        },
      ],
    },
    {
      linkId: "subscriberCity",
      text: "Subscriber City",
      type: "string",
      required: true,
      extension: [
        {
          url: "grid-size",
          valueCode: 4,
        },
      ],
    },
    {
      linkId: "subscriberState",
      text: "Subscriber State",
      type: "choice",
      required: true,
      option: stateOptions.map(option => ({
        valueString: option.label,
      })),
      extension: [
        {
          url: "grid-size",
          valueCode: 4,
        },
        {
          url: "component",
          valueString: "dropdown",
        },
      ],
    },
    {
      linkId: "subscriberZip",
      text: "Subscriber Zip",
      type: "string",
      required: true,
      extension: [
        {
          url: "grid-size",
          valueCode: 4,
        },
      ],
    },
    {
      linkId: "subscriberPhone",
      text: "Subscriber Phone",
      type: "string",
      required: true,
      code: [
        {
          code: "phoneNumber",
        },
      ],
      extension: [
        {
          url: "grid-size",
          valueCode: 6,
        },
      ],
    },
  ];
};

export const getConditionalItemsForGroup = (groupItem, groupValue) => {
  if (!groupItem || !Array.isArray(groupItem.item)) {
    return [];
  }

  const controllerItem = groupItem.item.find(item => {
    return (
      getQuestionnaireExtensionValue(item, "dropdown-onchange") ===
      "relationshipToSubscriber_select_change"
    );
  });

  if (!controllerItem) {
    return [];
  }

  const selectedValue = normalizeAnswerValue(
    groupValue ? groupValue[controllerItem.linkId] : null
  );

  if (!selectedValue || selectedValue === "self") {
    return [];
  }

  const existingLinkIds = new Set(groupItem.item.map(item => item.linkId));

  return buildSubscriberAddressItems().filter(
    item => !existingLinkIds.has(item.linkId)
  );
};

export const addConditionalItemsToQuestionnaire = (
  questionnaire,
  questionnaireData
) => {
  const modifiedQuestionnaire = JSON.parse(JSON.stringify(questionnaire));

  if (!modifiedQuestionnaire || !Array.isArray(modifiedQuestionnaire.item)) {
    return modifiedQuestionnaire;
  }

  modifiedQuestionnaire.item = modifiedQuestionnaire.item.map(item => {
    if (!(item.type === "group" && Array.isArray(item.item))) {
      return item;
    }

    const groupValues = item.repeats
      ? questionnaireData && Array.isArray(questionnaireData[item.linkId])
        ? questionnaireData[item.linkId]
        : []
      : [questionnaireData];
    const conditionalItems = [];

    groupValues.forEach(groupValue => {
      getConditionalItemsForGroup(item, groupValue).forEach(conditionalItem => {
        if (
          !conditionalItems.some(
            itemToCheck => itemToCheck.linkId === conditionalItem.linkId
          )
        ) {
          conditionalItems.push(conditionalItem);
        }
      });
    });

    if (conditionalItems.length < 1) {
      return item;
    }

    item.item = [...item.item, ...conditionalItems];

    return item;
  });

  return modifiedQuestionnaire;
};
